import React from 'react';

// Emoji flags (🇮🇹🇬🇧) render as bare letter codes on Windows/Firefox, which
// lack the OS-level flag glyphs — inline SVGs look the same everywhere.
export default function FlagIcon({ code, className = 'w-4 h-3 rounded-[2px]' }) {
  if (code === 'it') {
    return (
      <svg viewBox="0 0 3 2" className={className} aria-hidden="true">
        <rect width="1" height="2" x="0" fill="#009246" />
        <rect width="1" height="2" x="1" fill="#F1F2F1" />
        <rect width="1" height="2" x="2" fill="#CE2B37" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 60,30M60,0 0,30" stroke="#FFF" strokeWidth="6" />
      <path d="M0,0 60,30M60,0 0,30" stroke="#C8102E" strokeWidth="2" />
      <path d="M30,0 30,30M0,15 60,15" stroke="#FFF" strokeWidth="10" />
      <path d="M30,0 30,30M0,15 60,15" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}
